<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-12 17:25:51
-->
<template>
  <section class="rightContent">
    <div class="title">审核记录</div>
    <el-timeline v-if="goodsRecord.length">
      <el-timeline-item
        :hide-timestamp="true"
        placement="top"
        v-for="(item, index) in goodsRecord"
        :key="index"
      >
        <span :style="{ color: colorList[item.reviewType] }">{{
          statusList[item.reviewType]
        }}</span>
        <el-card>
          <p v-if="item.remark">备注：{{ item.remark || '-' }}</p>
          <p v-if="getCurrentStatus(item)">操作人：{{ item.opertator }}</p>
          <p>操作时间：{{ item.createTime }}</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <div class="noData" v-else>
      <img src="@/assets/imagess/es-sfss.png" alt="" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Live',
  data() {
    return {
      statusList: {
        1: '提交审核材料',
        2: '审核驳回',
        3: '审核通过'
      },
      colorList: {
        2: '#FF0000',
        3: '#669933'
      }
    }
  },
  props: {
    goodsRecord: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {},
  computed: {},
  created() { },
  mounted() { },
  methods: {
    // 驳回和通过时，企业和机构不展示操作人项
    getCurrentStatus(data) {
      const roleText = this.$store.state.user.userInfo.roleText
      if (data.reviewType == 2 || data.reviewType == 3) {
        return !(roleText === '机构' || roleText === '服务机构' || roleText == '企业')
      } else return true
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.rightContent {
  margin-left: 20px;
  width: 400px;
  height: calc(100% - 10px);
  background: white;
  overflow-y: scroll;
  .noData {
    text-align: center;
  }
  > .title {
    padding: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  > .text {
    color: rgba(102, 102, 102, 100);
    font-size: 14px;
  }
  /deep/ .el-card {
    border: none;
    box-shadow: none;
    // background-color: rgba(0, 0, 0, 0.02);
  }
  /deep/ .el-card__body {
    padding: 0;
  }
  /deep/ .el-timeline {
    padding: 0 15px;
    background: white;
  }
  /deep/ .el-timeline-item__node {
    background-color: rgba(24, 144, 255, 1);
  }
  /deep/ .el-timeline-item__tail {
    height: 88%;
    margin-top: 15px;
    border-left: 2px solid rgba(24, 144, 255, 1);
  }
}
</style>
